
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/d/search",
      function () {
        return require("private-next-pages/d/search.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/d/search"])
      });
    }
  